
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`Des accords de précommande ont été passés par plusieurs pays. En août 2021,
Novavax a toutefois repoussé la date à laquelle il entend demander au régulateur
américain une autorisation en urgence pour son vaccin. il estimait alors que
cette démarche serait entreprise au quatrième trimestre de l'année. Selon
l'agence Reuters, ce retard est lié à des difficultés d'approvisionnement pour
les matières premières nécessaires à la production.`}</p>
    <p>{`Des demandes d'utilisation en urgence ont été présentées en août en Inde, en
Indonésie et aux Philippines. Novavax a aussi annoncé le 23 septembre 2021 avoir
déposé une telle
`}<a parentName="p" {...{
        "href": "https://www.newswire.ca/fr/news-releases/novavax-et-le-serum-institute-of-india-presentent-a-l-organisation-mondiale-de-la-sante-une-demande-d-autorisation-d-utilisation-d-urgence-du-vaccin-contre-la-covid-19-de-novavax-896638843.html"
      }}>{`requête auprès de l'Organisation mondiale de la santé (OMS)`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;